import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LangLink } from './LangLink';
const CookieConsentBanner = ({ onAccept }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-neutral-800/95 dark:bg-neutral-900/95 backdrop-blur-sm text-white p-4 shadow-[0_-4px_12px_rgba(0,0,0,0.15)]">
      <div className="container-main flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-neutral-200 text-center sm:text-left">
          {t('cookie_consent.message')}{' '}
          <LangLink
            to="/privacy"
            className="font-semibold text-white underline hover:text-neutral-300 transition-colors"
          >
            {t('cookie_consent.privacy_policy_link')}
          </LangLink>
          .
        </p>
        <div className="flex-shrink-0">
          <button
            onClick={onAccept}
            className="bg-primary hover:bg-primary-dark text-white font-bold py-2 px-6 rounded-full transition-colors"
          >
            {t('cookie_consent.accept_button')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
